<template>
  <v-app v-if="setup" id="inspire">
    <v-app-bar
      v-if="displayHeader && !$vuetify.breakpoint.mobile && !$dav.isTotem"
      :color="setup && setup.theme && setup.theme.light && setup.theme.light.secondary ? 'secondary' : 'primary'"
      dark
      class="app-bar-prime"
      fixed
      app
      clipped-right
      height="64px"
    >
      <v-app-bar-nav-icon v-if="$route.path !== homeRoute">
        <v-btn
          v-if="displayNavigation"
          icon
          :title="$vuetify.lang.t('$vuetify.pages.home')"
          @click="$route.path !== homeRoute ? $router.push({ path: '/', query: $route.query }) : false"
        >
          <v-icon> home </v-icon>
        </v-btn>
      </v-app-bar-nav-icon>

      <!-- Title Page -->
      <v-toolbar-title data-app>
        <v-img v-if="setup" :src="setup.picture" width="248" height="36" contain alt="Doutor ao Vivo" />
      </v-toolbar-title>

      <v-spacer />

      <dav-chat-bubble></dav-chat-bubble>

      <v-badge
        v-if="display_messages_badge"
        right
        color="error"
        :content="count_unread_messages"
        :value="count_unread_messages"
        offset-x="25"
        offset-y="25"
        class="mr-2"
      >
        <v-btn id="page__messages" icon @click.stop="$router.push({ path: '/message', query: $route.query })">
          <v-icon size="30">notifications</v-icon>
        </v-btn>
      </v-badge>

      <primeit-toolbar-user-control
        v-if="displayNavigation"
        :role="role"
        :avatar="avatarPicture"
        :allowed-to-edit-profile="allowToEditProfile()"
        :allowed-register-dependent="validateButtonRegisterDependent()"
        :doctor-office="true"
      />
    </v-app-bar>

    <div v-if="$vuetify.breakpoint.mobile && showHeader && !$dav.isTotem" class="d-flex align-center mt-10 mx-5">
      <div @click="handleBack">
        <v-icon color="#000">mdi-chevron-left</v-icon>
      </div>
      <div class="d-flex justify-center" style="width: 100%">
        <span class="text-h5 black--text font-weight-medium">
          {{ mobileLabel }}
        </span>
      </div>
    </div>

    <v-main v-if="!dialogLogout" class="d-flex">
      <dav-accept-term-dialog v-if="listTerm.length > 0"></dav-accept-term-dialog>
      <primeit-message-snackbar />
      <!-- Page Content -->
      <router-view v-if="emergencyModule && listTerm.length === 0" />
      <pulse-loader v-else-if="!emergencyModule"></pulse-loader>
    </v-main>

    <!-- Footer content -->

    <!-- // VOU DEIXAR COMENTADO POR ENQUANTO
    <v-footer
      v-if="displayFooter"
      :color="setup && setup.theme && setup.theme.light && setup.theme.light.secondary ? 'secondary' : 'primary'"
      dark
      fixed
    >
      <div class="powered-by">
        <a style="color: inherit; text-decoration: inherit" href="https://www.doutoraovivo.com.br/" target="_blank">
          {{ $vuetify.lang.t('$vuetify.label.powered_by_dav') }}
        </a>
      </div>
    </v-footer> -->

    <!-- Progress -->
    <v-progress-circular v-show="isLoading" :size="50" color="primary" indeterminate />
    <!-- MultipleSnackBar -->

    <v-dialog v-model="dialogLogout" persistent width="500" :class="getMainClass()">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> Sessão encerrada </v-card-title>
        <v-card-text> Sua sessão excedeu o tempo limite </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="primary" text @click="logout()"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { CommonRouter } from '@primeit/components-vue';
import PulseLoader from '../../../components/PulseLoader';
import ChatBubble from '@/components/chat-bubble.component.vue';
import moment from 'moment';

export default {
  tag: 'common-sso',
  components: {
    PulseLoader,
    'dav-chat-bubble': ChatBubble,
  },
  data() {
    return {
      displayFooter: false,
      displayHeader: true,
      displayNavigation: true,
      breakpointMobile: 1280,
      dialogLogout: false,
      dialog: false,
      display_messages_badge: false,
      isLoading: false,
      drawer: true,
      left: false,
      right: false,
      mini: false,
      role: null,
      userName: null,
      menuUser: false,
      userLogged: null,
      count_unread_messages: null,
      counterEmergencyModule: 0,
      mobileLabel: this.$vuetify.lang.t(`$vuetify.pages.${this.$route.meta.label}`),
      avatarPicture: '',
    };
  },
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    routes() {
      return this.getAvailableRoutes(CommonRouter.registeredRoutes);
    },
    currentUser() {
      return this.$store.getters['credential/CURRENT_USER'];
    },
    customMessages() {
      return this.$store.getters['company/GET_ALL_CUSTOM_MESSAGES'];
    },
    countUnreadMessages() {
      return this.$store.getters['message/GET_COUNT_UNREAD'];
    },
    emergencyModule() {
      return this.$store.getters['contract/USE_EMERGENCY_MODULE'];
    },
    displayPoweredBy() {
      return this.$store.getters['contract/DISPLAY_POWERED_BY'];
    },
    listTerm() {
      return this.$store.getters['credential/TERM_USER'];
    },
    person() {
      return this.$store.getters['patient/GET_ONE'];
    },
    showHeader() {
      const routesHiddenHeader = ['/', '/emergency/person/', '/personschedule'];
      return !routesHiddenHeader.includes(this.$route.path);
    },
    homeRoute() {
      return '/';
    },
    message() {
      return this.$store.getters['message/GET_ONE'];
    },
  },
  watch: {
    emergencyModule() {
      this.counterEmergencyModule += 1;

      if (this.counterEmergencyModule == 2) {
        window.parent.postMessage({ loaded: true }, '*');
      }
    },
    countUnreadMessages(unread) {
      if (!unread || unread < 1) {
        this.count_unread_messages = 0;
      } else if (unread > 99) {
        this.count_unread_messages = '+99';
      } else {
        this.count_unread_messages = unread;
      }

      window.parent.postMessage(
        {
          event: 'update_unread_message_count',
          detail: {
            unread,
          },
        },
        '*'
      );
    },
    displayPoweredBy(val) {
      this.displayFooter = val && val.code === 200;
    },
    customMessages(val) {
      if (val && Array.isArray(val) && val.length > 0) {
        const language = Object.keys(val[0]).join();

        if (val[0][language]) {
          val[0][language].forEach((msg) => {
            const endPath = msg.code.replace('attendance.', '');
            // eslint-disable-next-line no-return-assign
            const setPath = (object, path, value) =>
              path.split('.').reduce((o, p, i) => (o[p] = path.split('.').length === ++i ? value : o[p] || {}), object);
            const langObj = this.$vuetify.lang.locales[language];
            setPath(langObj, endPath, msg.text);
          });
        }
      }
    },
    $route(to) {
      const title = this.$vuetify.lang.t(`$vuetify.pages.${to.meta.label}`);
      document.title = `${title} - ${sessionStorage.getItem('companyName')}`;

      this.mobileLabel = this.$vuetify.lang.t(`$vuetify.pages.${this.$route.meta.label}`);

      this.$root.$emit('route_changed');
    },
    'message.subject'(val) {
      if (val) {
        this.mobileLabel = val;
      }
    },
  },
  async created() {
    this.checkRedirectAccessAfterLogin();

    // vai realizar a segurança se o usuário aceitou os termos
    await this.$store.dispatch('credential/FETCH_TERM_USER');

    const vm = this;

    vm.$root.$on('route_changed', () => {
      if (vm.display_messages_badge) {
        vm.$store.dispatch('message/FETCH_COUNT_UNREAD');
      }
    });

    vm.$root.$on('message_visited', (val) => {
      vm.count_unread_messages = vm.count_unread_messages - val;
      if (vm.count_unread_messages < 0) vm.count_unread_messages = 0;
      window.parent.postMessage(
        {
          event: 'update_unread_message_count',
          detail: {
            unread: vm.count_unread_messages,
          },
        },
        '*'
      );
    });

    this.displayHeader = this.$route.query.header?.toUpperCase() !== 'OFF';
    this.displayNavigation = this.$route.query.navigation?.toUpperCase() !== 'OFF';

    this.$root.$on('display_footer_and_header', (val) => {
      this.displayFooter = val && this.displayPoweredBy && this.displayPoweredBy.code === 200;
      this.displayHeader = this.$route.query.header?.toUpperCase() === 'OFF' ? false : val;
    });

    this.overlay();
    this.listenEvents();

    await Promise.allSettled([
      this.$store.dispatch('domain/FETCH_STATUS_APPOINTMENT'),
      this.$store.dispatch('domain/FETCH_TYPE_USER'),
    ]);

    await this.$store.dispatch('company/FETCH_ALL_CUSTOM_MESSAGES', {
      fields: this.$vuetify.lang.current,
      id: this.setup.companyId,
    });

    const user = await this.$store.getters['credential/CURRENT_USER'];

    if (user) {
      await this.$store.dispatch('patient/FETCH_ONE', user.username);
      this.userLogged = user.signInUserSession.idToken.payload;
    }

    if (this.person?.picture) {
      this.avatarPicture = `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${this.person.picture}`;
    }

    window.parent.postMessage({ event: 'update_picture', picture: this.avatarPicture ?? '' }, '*');

    this.display_messages_badge =
      this.userLogged && this.userLogged['custom:roles'] === 'P' && this.setup?.settings?.message_module_enabled;

    if (this.display_messages_badge) {
      await this.$store.dispatch('message/FETCH_COUNT_UNREAD');
    }

    const companyId = user.signInUserSession.idToken.payload.family_name;

    await this.setDisplayFooter(companyId);

    if (this.setup?.name) {
      sessionStorage.setItem('companyName', this.setup.name);
      document.title = `${this.setup.name}`;
    } else {
      sessionStorage.setItem('companyName', '');
      document.title = '';
    }

    if (user) {
      const role = user.signInUserSession.idToken.payload['custom:roles'];
      const types = await this.$store.getters['domain/GET_TYPE_USER'];
      const roleAux = types.find((type) => type.code === role).value;
      if (!this.role && roleAux) {
        this.role = roleAux;
      }
      this.userName = user.signInUserSession.idToken.payload.name;
      this.userName = this.userName.split(' ')[0];
    }

    this.$root.$on('hide_footer', () => {
      this.displayFooter = false;
    });
  },
  mounted() {
    window.addEventListener('message', (e) => {
      const message = e.data;

      if (message.event === 'update_picture') {
        this.avatarPicture = message.picture;
      }
    });
  },
  methods: {
    async handleBack() {
      const { path } = this.$route;
      const currentPage = path.split('/')[2];

      if (path.startsWith('/message/')) {
        if (currentPage === 'detail' || currentPage === 'new') {
          return this.$router.push({ path: '/message', query: this.$route.query });
        }
      }

      this.$router.push({ path: '/', query: this.$route.query });
    },
    checkRedirectAccessAfterLogin() {
      try {
        const redirect = localStorage.getItem('init_page') || window.parent?.localStorage?.getItem('init_page');
        if (redirect) {
          localStorage.removeItem('init_page');
          return this.$router.push({ path: `/${redirect}`, query: this.$route.query });
        }
      } catch (e) {
        /// Rever - ISSO DÁ PROBLEMA COM O PSO
      }
    },
    isAttendanceRoom() {
      return this.$route?.name?.includes('ATTENDANCE_ROOM');
    },
    getMainClass() {
      if (this.isAttendanceRoom()) {
        return 'mb-5';
      }
      return '';
    },
    async setDisplayFooter(companyId) {
      await this.$store.dispatch('contract/FETCH_CONTRACT_DISPLAY_POWERED_BY', { companyId: companyId });
    },
    allowToEditProfile() {
      const role = this.currentUser?.signInUserSession.idToken.payload['custom:roles'];
      if (role === 'P') return this.setup.settings.allow_person_edit_profile;
    },
    signOutIcon() {
      this.dialog = true;
    },
    listenEvents() {
      const vm = this;
      vm.$root.$on('show-dialog', function () {
        vm.showDialog();
      });
    },
    overlay() {
      this.drawer = window.innerWidth > this.breakpointMobile;
    },
    logout() {
      this.$store.dispatch('credential/LOGOUT');
    },
    pageName(label) {
      return this.$vuetify.lang.t('$vuetify.pages.' + label);
    },
    showDialog() {
      this.dialogLogout = true;
    },
    getAvailableRoutes(routes) {
      const availableRoutes = routes;
      // roles do tipo de usário
      const userRoles = [this.userLogged ? this.userLogged['custom:roles'] : ''];
      // regras de settings
      const allowsPatientToSchedule = this.setup.settings.allows_patient_to_schedule
        ? 'allows_patient_to_schedule'
        : '';

      const visibleRules = [allowsPatientToSchedule];

      availableRoutes.forEach((att) => {
        // se possui roles configurada vai verificar se o usuario possui
        if (att.userRoles && att.userRoles.length > 0) {
          let visible = false;
          for (const rule of att.userRoles) {
            if (userRoles.includes(rule)) {
              visible = true;
              break;
            }
          }
          att.visible = visible;
        }

        // se o menu continua visivel, verifica regras de settins caso tenha
        if (att.visible && att.visibleRules && att.visibleRules.length > 0) {
          let visible = true;
          for (const rule of att.visibleRules) {
            if (!visibleRules.includes(rule)) {
              visible = false;
              break;
            }
          }
          att.visible = visible;
        }
      });

      return availableRoutes.filter((route) => route.visible);
    },
    validateButtonRegisterDependent() {
      const role = this.currentUser?.signInUserSession.idToken.payload['custom:roles'];
      let show = false;

      if (role === 'P') {
        if (this.setup.settings.allow_holder_register_dependents) {
          if (this.person?.parent_id) {
            show = false;
            return;
          }
          show = true;
        }
      }

      return show;
    },
    getGreet() {
      const hour = moment().hours();

      if (hour >= 0 && hour <= 12) {
        return this.$vuetify.lang.t('$vuetify.label.goodMorning');
      }
      if (hour > 12 && hour < 18) {
        return this.$vuetify.lang.t('$vuetify.label.goodAfternoon');
      }
      if (hour >= 18 && hour <= 24) {
        return this.$vuetify.lang.t('$vuetify.label.goodEvening');
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.page-wrapper {
  min-height: calc(100vh - 140px - 50px - 0px);
}
.powered-by {
  float: right;
  margin-left: auto;
  font-size: x-small;
  font-weight: 100;
  word-spacing: 2px;
}
</style>
